import { CustomRoutes, localStorageStore, Admin as ReactAdmin } from 'react-admin'
import { BrowserRouter, Route } from 'react-router-dom'
import Layout from '../layout/Layout'
import { theme as xxTheme } from '../layout/themes'
import LoginPage from '../pages/Login'
import Settings from '../pages/Settings'
import Unauthorized from '../pages/Unauthorized'
import VerzoekDetail from '../pages/VerzoekDetail'
import Verzoekenoverzicht from '../pages/Verzoekenoverzicht'
import providers from '../providers'
import { Permissions } from '../types/apiTypes'
import { resourcesForScopes } from './Resources'

const store = localStorageStore()

const Admin = (): JSX.Element => (
  <BrowserRouter>
    {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
    {/* @ts-ignore */}
    <ReactAdmin
      i18nProvider={providers.i18n}
      authProvider={providers.auth()}
      dataProvider={providers.data}
      layout={Layout}
      loginPage={LoginPage}
      disableTelemetry
      theme={xxTheme}
      store={store}
    >
      { (permissions: Permissions): JSX.Element[] => resourcesForScopes(permissions) }
      <CustomRoutes>
        <Route path="/settings" element={<Settings />} />
        <Route path="/verzoekenoverzicht" element={<Verzoekenoverzicht />} />
        <Route path="/verzoekenoverzicht/:verzoeknummer" element={<VerzoekDetail />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </CustomRoutes>
    </ReactAdmin>
  </BrowserRouter>
)

export default Admin
